import * as React from 'react';
import { useFormikContext } from 'formik';
import type {
  CheckoutFormValues,
  CheckoutPaymentMethod,
  SelectedAppointment,
} from '../../types/appointments';

interface Props {
  appointment: SelectedAppointment | null;
  enabledPaymentMethods: CheckoutPaymentMethod[];
}

export function shouldClearPaymentMethod(
  paymentMethod: CheckoutPaymentMethod | undefined,
  enabledPaymentMethods: CheckoutPaymentMethod[],
): boolean {
  return !!paymentMethod && !enabledPaymentMethods.includes(paymentMethod);
}

export function shouldClearAdditionalServices(
  appointment: SelectedAppointment | null,
  additionalServices: CheckoutFormValues['additionalServices'],
): boolean {
  return !appointment && !!additionalServices?.length;
}

export function CheckoutFormGuard({
  appointment,
  enabledPaymentMethods,
}: Props) {
  const { values, setFieldValue } = useFormikContext<CheckoutFormValues>();

  React.useEffect(() => {
    if (shouldClearPaymentMethod(values.paymentMethod, enabledPaymentMethods)) {
      setFieldValue('paymentMethod', undefined);
    }
  }, [enabledPaymentMethods, values.paymentMethod, setFieldValue]);

  React.useEffect(() => {
    if (shouldClearAdditionalServices(appointment, values.additionalServices)) {
      setFieldValue('additionalServices', []);
    }
  }, [appointment, values.additionalServices, setFieldValue]);

  return null;
}
